import ProgressBar from "components/ProgressBar/ProgressBar";
import { getListActionProgress } from "containers/Resources/Resources.selectors";
import { useSelector } from "react-redux";
import "./ListActionProgress.scss";

export const ListActionProgress = () => {
    const progress = useSelector(getListActionProgress);

    if (!progress) {
        return null;
    }

    const percentage =
        progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0;

    return (
        <div className="listActionProgress" role="status" aria-live="polite">
            <span className="listActionProgress__label">
                {progress.label} ({progress.current}/{progress.total})
            </span>
            <ProgressBar percentage={percentage} />
        </div>
    );
};
